"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".min-h-text[_ngcontent-%COMP%]{height:250px}\n/*# sourceMappingURL=contact-user.component.css.map*/"];
exports.styles = styles;
